import React, { forwardRef, useContext } from 'react';
import { useEntryPointButtonTrigger } from '@atlassian/jira-entry-point-button-trigger/src/index.tsx';
import { IssueSmartRequestSummaryEntryPointContext } from '@atlassian/jira-issue-view-smart-request-summary-entrypoint/src/index.tsx';
import useMergeRefs from '@atlassian/jira-merge-refs/src/index.tsx';
import { SummaryStateContainer } from '@atlassian/jira-issue-smart-request-summary-state/src/ui/index.tsx';
import { Trigger } from '@atlassian/jira-issue-smart-request-summary-trigger/src/ui/index.tsx';

const IssueSmartRequestSummaryTriggerNew = forwardRef<
	HTMLButtonElement,
	{ isCompact: boolean; totalComments?: number; hasComments?: boolean }
>((props, ref) => {
	const issueSmartRequestSummaryEntryPoint = useContext(IssueSmartRequestSummaryEntryPointContext);

	const entryPointTriggerRef = useEntryPointButtonTrigger(
		issueSmartRequestSummaryEntryPoint.entryPointActions,
	);

	const triggerRef = useMergeRefs(ref, entryPointTriggerRef);

	return (
		<SummaryStateContainer>
			<Trigger {...props} ref={triggerRef} />
		</SummaryStateContainer>
	);
});

export default IssueSmartRequestSummaryTriggerNew;
